
export class FormValidator {
    constructor(data, formElement) {
        this._formElement = formElement;
        this._inputSelector = data.inputSelector;
        this._inputErrorClass = data.inputErrorClass;
        this._errorClass = data.errorClass;
        this._submitButtonSelector = data.submitButtonSelector;
        this._inputBorderErrorClass = data.inputBorderErrorClass;
        this._inactiveButtonClass = data.inactiveButtonClass;
        this._inputList = Array.from(this._formElement.querySelectorAll(this._inputSelector));
        this._button = this._formElement.querySelector(this._submitButtonSelector);
    };

    _showInputError(input) {
        this._errorElement = document.querySelector(`.${this._inputErrorClass}${input.id}`);
        this._errorElement.textContent = input.validationMessage;
        this._errorElement.classList.add(this._errorClass);
        input.classList.add(this._inputBorderErrorClass);
    };

    _hideInputError(input) {
        this._errorElement = document.querySelector(`.${this._inputErrorClass}${input.id}`);
        this._errorElement.textContent = '';
        this._errorElement.classList.remove(this._errorClass);
        input.classList.remove(this._inputBorderErrorClass);
    };

    clearInputErrors() {
        this._inputList.forEach((input) => {
            this._hideInputError(input);
        })
    };

    disableButton() {
        this._button.classList.add(this._inactiveButtonClass);
        this._button.setAttribute('disabled', true);
    };

    enableButton() {
        this._button.classList.remove(this._inactiveButtonClass);
        this._button.removeAttribute('disabled');
    };

    _checkInputValidity(input) {
        if(!input.validity.valid) {
            this._showInputError(input);
        } else {
            this._hideInputError(input);
        }
    };

    _hasInvalidInput() {
        return this._inputList.some(input => {
            return !input.validity.valid
        });
    };

    _toggleButtonState() {
        if( this._hasInvalidInput() ) {
            this.disableButton();
        } else {
            this.enableButton();
        }
    };

    _setEventListeners() {
        this._inputList.forEach(input => {
            input.addEventListener('input', () => {
                this._checkInputValidity(input);
                this._toggleButtonState();
            })
        })
    };

    enableValidation() {
        this._setEventListeners()
    } ;
}